'use client'

import { LineHelpCircle } from '@qr-front/icons/line-help-circle'
import { useRef } from 'react'

import { cn } from '@/utils'

import { Tooltip } from './Tooltip'

// Question-mark help icon that shows `content` on hover (desktop) / tap (mobile).
// Touch/hover handling lives in Tooltip.
export const FieldTooltip = ({
	content,
	className,
}: {
	content: string
	className?: string
}) => {
	const ref = useRef<HTMLButtonElement>(null)

	return (
		<>
			<button
				ref={ref}
				type="button"
				aria-label={content}
				className={cn(
					'flex text-grey transition-colors hover:text-blue',
					className,
				)}
			>
				<LineHelpCircle className="size-4" />
			</button>
			<Tooltip
				anchorRef={ref}
				delay={200}
				visual="field"
				position="top-end"
			>
				{content}
			</Tooltip>
		</>
	)
}
